// Click tone via Web Audio. Howler is in deps for Phase 2 when we have real
// SFX files, but we don't need it for a generated tone.
//
// Browsers gate AudioContext until a user gesture — we lazy-init on first
// interaction so the page doesn't log warnings on load.

let ctx = null

function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)()
  if (ctx.state === 'suspended') ctx.resume()
  return ctx
}

export function playClick() {
  try {
    const c = getCtx()
    const osc = c.createOscillator()
    const gain = c.createGain()
    osc.type = 'sine'
    osc.frequency.setValueAtTime(620, c.currentTime)
    osc.frequency.exponentialRampToValueAtTime(380, c.currentTime + 0.07)
    gain.gain.setValueAtTime(0.18, c.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + 0.08)
    osc.connect(gain).connect(c.destination)
    osc.start()
    osc.stop(c.currentTime + 0.09)
  } catch (err) {
    // No-op — audio is decorative.
    console.debug('[audio] click skipped:', err)
  }
}

// A soft, rising four-note chime (purchase celebration). Silent if the browser still blocks audio (no click yet this visit).
export function playChime() {
  try {
    const c = getCtx()
    if (c.state !== 'running') return
    ;[523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      const t = c.currentTime + i * 0.11
      const osc = c.createOscillator()
      const gain = c.createGain()
      osc.type = 'sine'
      osc.frequency.setValueAtTime(f, t)
      gain.gain.setValueAtTime(0.0001, t)
      gain.gain.exponentialRampToValueAtTime(0.12, t + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.7)
      osc.connect(gain).connect(c.destination)
      osc.start(t)
      osc.stop(t + 0.75)
    })
  } catch (err) {
    console.debug('[audio] chime skipped:', err)
  }
}

// PHASE 2: load real SFX via Howler and add ambience tracks per season.
